<template>
  <div ref="steps-container" class="steps-container scroll-design">
    <transition name="botao-voltar">
      <button
        @click="voltarAba(indexAtual - 1)"
        class="botao-voltar"
        v-if="indexAtual > 0"
      >
        <unicom-icone nome="chevron-left" :tamanho="16" />
      </button>
    </transition>
    <button
      ref="step"
      v-for="(item, index) in abas"
      :key="index"
      :class="`step ${tamanhoTela} ${habilitar(item.atual)}`"
      :disabled="!item.ativo"
      :style="estiloStep"
      @click="clickStep(index)"
    >
      <h3 class="fonte-secundaria medio">
        {{ zeroEsquerda(index + 1, 2) }} - {{ item.nome }}
      </h3>
    </button>
    <div class="wrapper-total" :style="estiloTotal" ref="total" />
    <div class="wrapper" :style="estiloWrapper">
      <div class="slider" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    abas: {
      type: Array,
      required: true,
      note:
        "Recebe os itens que formam as abas dos steps, deve ser um objeto com: nome e ativo"
    },
    tamanhoTela: {
      type: String,
      required: false,
      default: "web",
      note: "Recebe valores referentes ao tamanho da tela (web ou mobile)"
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.verificarMobile();
      this.clickStep(0);
      window.addEventListener("resize", () => {
        this.resetarLargura();
      });
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.resetarLargura());
  },
  methods: {
    resetarLargura() {
      if (this.indexAtual === 0) {
        this.larguraWrapper = 0;
        return;
      }

      this.larguraWrapper = `${(100 / this.abas.length) *
        (this.indexAtual + 1)}`;
    },
    voltarAba(indexAnterior) {
      if (this.abas[indexAnterior].ativo === false) {
        return this.voltarAba(indexAnterior - 1);
      }
      this.clickStep(indexAnterior);
    },
    habilitar(atual) {
      return atual ? "atual" : "";
    },
    clickStep(index) {
      if (this.indexAtual === index) {
        return;
      }

      this.indexAtual = index;
      this.$emit("click", index);

      if (index === 0) {
        this.larguraWrapper = 0;
        return;
      }

      this.larguraWrapper = `${(100 / this.abas.length) * (index + 1)}`;
    },
    calcularLarguraTotal() {
      setTimeout(() => {
        const { scrollWidth } = this.$refs["steps-container"];

        this.larguraWrapperTotal = scrollWidth;
      }, 10);
    },
    verificarMobile() {
      if (this.isMobile) {
        this.calcularLarguraTotal();
      }
    },
    carregarAbas() {
      const indexAtual = this.abas.findIndex(e => e.atual);
      if (indexAtual === -1) return;

      this.clickStep(indexAtual);
    }
  },
  data() {
    return {
      indexAtual: -1,
      larguraWrapper: 100 / this.abas.length,
      leftWrapper: 0,
      larguraWrapperTotal: null
    };
  },
  computed: {
    estiloStep() {
      return {
        width: `calc(100% / ${this.abas.length})`
      };
    },
    estiloWrapper() {
      return {
        left: `0px`,
        width: `${this.larguraWrapper}%`
      };
    },
    estiloTotal() {
      if (!this.isMobile) {
        return {};
      }
      return {
        width: `${this.larguraWrapperTotal}px`
      };
    },
    isMobile() {
      return this.$breakpoint.smAndDown;
    }
  },
  watch: {
    isMobile() {
      this.verificarMobile();
    },
    abas: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.carregarAbas();
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "StepRelatorio";
</style>
